/** True while the socket is still connecting or already open. */
export function isSocketConnectingOrOpen(ws: WebSocket | null | undefined): boolean {
  return ws?.readyState === WebSocket.CONNECTING || ws?.readyState === WebSocket.OPEN;
}

/** True only once the socket is fully open, ready to send. */
export function isSocketOpen(ws: WebSocket | null | undefined): boolean {
  return ws?.readyState === WebSocket.OPEN;
}
